import { PREVIEWS_CONFIG } from '../config/preview-config';

const DEFAULT_MAX_LINES = 3;

/**
 * Obtiene el límite de líneas para una combinación stage + channel + variant
 * Default: 3 líneas
 */
export const getMaxLinesForVariant = (stage: string, channel: string, variant: string): number => {
  const config = PREVIEWS_CONFIG[stage]?.[channel];

  if (!config) return DEFAULT_MAX_LINES;

  if (!config.maxLines) return DEFAULT_MAX_LINES;

  return config.maxLines[variant] ?? DEFAULT_MAX_LINES;
};
